import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MpsMaintenanceService {
  isInMaintenance = false;
  retryAfterSeconds = 0;
}
